(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-title"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(e) {
    if (e.target.name === 'id') {
      const variantId = e.target.value;
      const form = e.target.closest('form[data-product-id]');
      const productId = form ? form.dataset.productId : null;

      fetch('/variants/' + variantId + '.js')
        .then(function(r) { return r.json(); })
        .then(function(variant) {
          const selector = productId
            ? '[data-show-stock="true"][data-product-id="' + productId + '"]'
            : '[data-show-stock="true"]';
          const el = document.querySelector(selector);
          if (!el) return;

          if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0) {
            el.textContent = 'Only ' + variant.inventory_quantity + ' left!';
            el.style.display = 'inline-block';
          } else {
            el.style.display = 'none';
          }
        });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
